import {Dialog, Transition} from '@headlessui/react';
import React, {useState, Fragment, useRef, useEffect} from 'react';
import {ExclamationTriangleIcon} from '@heroicons/react/24/outline';
import {ShieldCheckIcon} from '@heroicons/react/24/outline';
import CloseIcon from '@mui/icons-material/Close';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {ToastContainer} from 'react-toastify';
import ShoppingCartRoundedIcon from '@mui/icons-material/ShoppingCartRounded';
import {useContext} from 'react';
import {Context} from '../../../Helpers/Auth';
import AddShoppingCartRoundedIcon from '@mui/icons-material/AddShoppingCartRounded';

// import { Container } from './styles';

function QuantidadeItemModal({cancelar, aprovar, item}) {
    const cancelButtonRef = useRef(null);
    const {t} = useTranslation();
    const [opcoesAprovacao, setOpcoesAprovacao] = useState([]);
    const [aprovacao, setAprovacao] = useState(null);
    const [justificacao, setJustificacao] = useState('');
    const {isCard, openCards, setCarrinhoItems, carrinhoItems} = useContext(Context);
    const [quantidade, setQuantidade] = useState(1);

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    const handleAddToCart = () => {
        const itemComQuantidade = {...item, quantidade};
        setCarrinhoItems([...carrinhoItems, itemComQuantidade]);
        toast.success(t('addCarrinho'), {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
        });
        cancelar();
    };

    const incrementarQuantidade = () => {
        setQuantidade(quantidade + 1);
    };

    const decrementarQuantidade = () => {
        if (quantidade > 1) {
            setQuantidade(quantidade - 1);
        }
    };

    return (
        <Transition.Root show as={Fragment}>
            <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={() => cancelar()}>
                <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                            <Dialog.Panel className="relative transform overflow-hidden rounded-[8px] bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                                <div className="flex items-center justify-between px-4 py-2 border-b rounded-t bg-gray-50 border-gray-100">
                                    <div className="flex flex-row">
                                        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10">
                                            <AddShoppingCartRoundedIcon className="h-6 w-6 text-green-600" aria-hidden="true" />
                                        </div>
                                        <h3 className="text-xl ml-4 mt-2 font-semibold text-gray-600 ">{t('quantidadeProduto')}</h3>
                                    </div>
                                    <button
                                        type="button"
                                        className="inline-flex justify-end rounded-[8px] text-gray-500 px-1 py-1 text-sm font-semibold  shadow-sm hover:bg-gray-200 sm:ml-3 sm:w-auto"
                                        onClick={() => cancelar()}>
                                        <CloseIcon />
                                    </button>
                                </div>
                                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4 flex flex-row justify-center">
                                    <div className="flex items-center max-[500px]:justify-center h-full max-md:mt-3">
                                        <div className="flex items-center h-full">
                                            <button
                                                onClick={e => {
                                                    decrementarQuantidade();
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                }}
                                                className="group rounded-l-xl px-5 py-[18px] border border-gray-200    flex items-center justify-center shadow-sm shadow-transparent transition-all duration-500 hover:bg-gray-50 dark:bg-gray-300 dark:hover:bg-gray-200 hover:border-gray-300 hover:shadow-gray-300 focus-within:outline-gray-300">
                                                <svg
                                                    className="stroke-gray-900 transition-all duration-500 group-hover:stroke-black"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="22"
                                                    height="22"
                                                    viewBox="0 0 22 22"
                                                    fill="none">
                                                    <path d="M16.5 11H5.5" stroke="" stroke-width="1.6" stroke-linecap="round" />
                                                    <path d="M16.5 11H5.5" stroke="" stroke-opacity="0.2" stroke-width="1.6" stroke-linecap="round" />
                                                    <path d="M16.5 11H5.5" stroke="" stroke-opacity="0.2" stroke-width="1.6" stroke-linecap="round" />
                                                </svg>
                                            </button>
                                            <input
                                                type="text"
                                                className="border-y border-gray-200 dark:bg-gray-50 outline-none text-gray-900 font-semibold text-lg w-full max-w-[73px] min-w-[60px] placeholder:text-gray-900 py-[15px]  text-center bg-transparent"
                                                // placeholder="1"
                                                value={quantidade}
                                                readOnly
                                            />
                                            <button
                                                onClick={e => {
                                                    incrementarQuantidade();
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                }}
                                                className="group rounded-r-xl px-5 py-[18px] border dark:bg-gray-300 border-gray-200 dark:hover:bg-gray-200 flex items-center justify-center shadow-sm shadow-transparent transition-all duration-500 hover:bg-gray-50 hover:border-gray-300 hover:shadow-gray-300 focus-within:outline-gray-300">
                                                <svg
                                                    className="stroke-gray-900 transition-all duration-500 group-hover:stroke-black"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="22"
                                                    height="22"
                                                    viewBox="0 0 22 22"
                                                    fill="none">
                                                    <path d="M11 5.5V16.5M16.5 11H5.5" stroke="" stroke-width="1.6" stroke-linecap="round" />
                                                    <path d="M11 5.5V16.5M16.5 11H5.5" stroke="" stroke-opacity="0.2" stroke-width="1.6" stroke-linecap="round" />
                                                    <path d="M11 5.5V16.5M16.5 11H5.5" stroke="" stroke-opacity="0.2" stroke-width="1.6" stroke-linecap="round" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                    <button
                                        type="button"
                                        className="inline-flex w-full justify-center rounded-[8px] bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
                                        onClick={() => {
                                            handleAddToCart();
                                        }}>
                                        {t('guardar')}
                                    </button>
                                    <button
                                        type="button"
                                        className="mt-3 inline-flex w-full justify-center rounded-[8px] bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                        onClick={() => cancelar()}
                                        ref={cancelButtonRef}>
                                        {t('cancelar')}
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}

export default QuantidadeItemModal;
